
import Breadcrumb from "../library/breadcrumb.vue"
import StoreCard from "@/components/StoreLocator/StoreCard.vue"
import StoreMap from "@/components/StoreLocator/StoreMap.vue"
import StoreLocatorFilter from "@/components/StoreLocator/StoreLocatorFilter.vue"
import { queryStoreLocator, queryStoreLocatorFilter } from "@/api/storeLocator"
import { Logger } from "@/plugins/logger"
import { getRequestHeaders } from "@/utils/utils"
import { FILTER_KEY, FilterMap } from "@/constants/storeLocator"

export default {
  name: "GoogleMap",
  components: {
    StoreCard,
    StoreLocatorFilter,
    Breadcrumb,
    StoreMap
  },
  async asyncData({ req, error, store }) {
    try {
      const venderBrandId = store.state.commonParams.venderBrandId
      const storeListResponse = await queryStoreLocator(
        {
          venderBrandId
        },
        {
          headers: getRequestHeaders({ req, store })
        }
      )
      const servicesResponse = await queryStoreLocatorFilter(
        { venderBrandId },
        {
          headers: getRequestHeaders({ req, store })
        }
      )

      return {
        filterStoreList: storeListResponse.data,
        services: servicesResponse.data,
        currentStoreId: storeListResponse.data?.[0]?.storeId
      }
    } catch (err) {
      Logger.error("store locator 初始化报错", err)
      error({
        statusCode: 500,
        message: "Store not found"
      })
    }
  },
  data() {
    return {
      isFullMap: false,
      activeTab: "list-view",
      storeList: [],
      services: [],
      filterStoreList: [],
      currentStoreId: null,
      position: {
        latitude: 0,
        longitude: 0
      }
    }
  },
  head() {
    return {
      title: `${this.$t("pageTitle.storeLocator")}`
    }
  },
  computed: {
    servicesOptions() {
      return this.services.map(item => {
        return {
          value: item.id,
          label: item.name,
          icon: item.imgUrl
        }
      })
    }
  },
  mounted() {
    this.handleTriggerPosition()
    this.storeList = this.filterStoreList
  },
  methods: {
    handleTriggerPosition() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.setLocation, this.showError)
      } else {
        console.log("Geolocation is not supported by this browser.")
      }
    },
    setLocation(position) {
      const latitude = position.coords.latitude
      const longitude = position.coords.longitude
      this.position = { latitude, longitude }
      this.fetchStoreList()
    },
    fetchStoreList() {
      queryStoreLocator({
        venderBrandId: this.$store.state.commonParams.venderBrandId,
        latitude: this.position.latitude,
        longitude: this.position.longitude
      }).then(res => {
        this.storeList = res.data
        this.filterStoreList = this.storeList
        this.currentStoreId = this.filterStoreList?.[0]?.storeId
      })
    },
    handleChangeFilter(filter) {
      let filterList = this.storeList
      Object.keys(filter).forEach(key => {
        if (filter[key]) {
          if (key === FILTER_KEY.SEARCH) {
            filterList = filterList.filter(item => {
              const filterValue = filter[key].toLowerCase()
              return (
                item.storeName?.toLowerCase()?.includes(filterValue) ||
                item.storeAddress?.toLowerCase()?.includes(filterValue)
              )
            })
          } else if (key === FILTER_KEY.SERVICES) {
            filterList = filterList.filter(item => {
              return item?.serviceIds?.includes(String(filter[key]))
            })
          } else {
            filterList = filterList.filter(item => {
              return filter[key] == item[FilterMap[key]]
            })
          }
        }
      })
      this.filterStoreList = filterList
    },
    scrollToElement(id) {
      if (this.$refs.storeList) {
        const index = this.filterStoreList.findIndex(item => item.storeId === id)
        if (index) {
          const el = this.$refs.storeList.children[index]
          if (!el) return
          el.scrollIntoView({ behavior: "smooth", block: "center" })
        }
      }
    },
    handleChangeCurrentStoreId(id) {
      this.scrollToElement(id)
      this.currentStoreId = id
    },
    showError() {
      this.$message({
        type: "warning",
        message: this.$t("storeLocator.locationError")
      })
    }
  }
}
